class Analytics {
    constructor(options) {
        this.options = options;
        this.maximumFreetextLength = 30;

        if (this.options.trackingActive) {
            window.mixpanel.register({ ...this.getDefaultEventProperties() });
        }
    }

    trackPageView(name) {
        if (!this.options.trackingActive) {
            return;
        }
        window.trackPageView(name);
    }

    trackEvent(name, params) {
        if (!this.options.trackingActive) {
            return;
        }

        window.trackEvent(name, params);
    }

    reportUserLoggedIn(user, auth, isNewSignup) {
        if (!this.options.trackingActive) {
            return;
        }

        let username = auth['cognito:username'];
        if (!isNewSignup && typeof window.mixpanel.identify === 'function') {
            window.mixpanel.identify(username);
        } else if (isNewSignup && typeof window.mixpanel.get_distinct_id === 'function') {
            window.mixpanel.alias(username, window.mixpanel.get_distinct_id());
        }

        window.mixpanel.register({
            ...this.getDefaultEventProperties(),
            is_logged_in: true,
            isInternalUser: !!auth['custom:is_internal_user'],
            consumerProfileID: user?.id,
        });
        window.mixpanel.people.set({
            is_logged_in: true,
            isInternalUser: !!auth['custom:is_internal_user'],
            profileID: user?.id,
            $onesignal_user_id: username,
        });
    }

    reportUserLoggedOut() {
        if (!this.options.trackingActive) {
            return;
        }

        if (window.mixpanel !== undefined) {
            window.mixpanel.reset();
        }

        let props = {
            is_logged_in: false,
            isInternalUser: false,
            consumerProfileID: null,
            profileID: null,
            $onesignal_user_id: null,
        };

        window.mixpanel.register({ ...this.getDefaultEventProperties(), ...props });
        window.mixpanel.people.set(props);
    }

    getDefaultEventProperties() {
        return {
            platform: 'web',
            device_languages: navigator.languages,
        };
    }
    postParams(post) {
        return {
            item_id: post.id,
            item_name: this.shortenedText(post.caption ? post.caption : ''),
            content_url: post.url,
            profile_id: post.profile.id,
            has_photo: !!post.image,
            has_caption: !!post.caption,
        };
    }
    postWithSensitiveDataParams(post, profile) {
        return {
            item_id: post.id,
            item_name: this.shortenedText(post.caption ? post.caption : ''),
            content_url: post.url,
            profile_id: profile.id,
            has_photo: !!post.image,
            has_caption: !!post.caption,
        };
    }

    campaignParams(campaign) {
        return {
            campaign_id: campaign.id,
            campaign_prompt: campaign.promptText,
            campaign_url: campaign.contributionURL,
            profile_id: campaign.profile.id,
            success_text: campaign.successText,
            success_link: campaign.successLink,
            success_link_label: campaign.successLinkLabel,
            enforces_consent: campaign.enforcesTermsAndConditionsConsent,
        };
    }

    profileParams(profile) {
        return {
            item_id: profile.id,
            item_name: this.shortenedText(profile.name ? profile.name : ''),
            content_url: profile.url,
            profile_id: profile.id,
            has_photo: !!profile.image,
        };
    }

    productParams(product) {
        return product;
    }

    playParams(state, audioState) {
        let generalParams = {
            item_id: audioState.post.id,
            item_name: this.shortenedText(audioState.post.caption ? audioState.post.caption : ''),
            content_url: audioState.post.url,
            profile_id: audioState.post.profile.id,
            appInForeground: 'not-set',
            playbackSpeed: '1.0',
        };

        let fullParams = (completed) => ({
            played: `${Math.round(audioState.player.currentTime * 10) / 10}`,
            duration: `${Math.round(audioState.player.duration * 10) / 10}`,
            completed: !!completed,
        });

        switch (state) {
            case 'began':
                return generalParams;
            case 'partial':
                return { ...generalParams, ...fullParams(false) };
            case 'completed':
                return { ...generalParams, ...fullParams(true) };
        }
    }

    shortenedText(original) {
        return original.substr(0, this.maximumFreetextLength);
    }
}

export default (_, inject) => {
    const analyitics = new Analytics({
        trackingActive: !window.Cypress,
    });
    inject('analytics', analyitics);
    analyitics.trackEvent('appOpened');
};

// const analytics = {
//     install(Vue, options) {
//         const analytics = new Analytics(options);
//         Vue.prototype.$analytics = analytics;

//         analytics.trackEvent('appOpened');
//     },
// };

// export default function ({ $config }) {
//     Vue.use(analytics, {});
// }
